import script from "./PostView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostView.vue?vue&type=script&setup=true&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=0fb43c98&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb43c98"]])

export default __exports__